import DBOperations from "src/utils/dbOperations";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";

async function getSequenceGroup(sequenceGroupID) {
  try {
    return await DBOperations.getData(
      Constants.enums.TABLES_NAME_ENUM.SEQUENCE_ROUTING_TABLE,
      sequenceGroupID
    );
  } catch (error) {
    console.error(error);
    Exception.catchException(error);
    return null;
  }
}

async function getNextSequenceValue(sequenceName) {
  try {
    return await DBOperations.getNextSequenceValue(sequenceName);
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  getSequenceGroup,
  getNextSequenceValue
};
